



































































































































import { Component, Vue } from 'vue-property-decorator';
import { SearchVesselsParams } from '@/types/search/SearchVesselsParams';
import { CLEAR_VESSELS, RESET_STATE_FILTERS, SEARCH_VESSELS, SET_PAGE, SET_VESSELS_FILTER } from '@/store/vessels';
import { clearEmpty } from '@/helpers';
import { mixins } from 'vue-class-component';
import FiltersIcon from '@/svg/filter.svg';
import LocationIcon from '@/svg/location.svg';
import UiKitInput from '@/components/UiKit/UiKitInput.vue';
import VesselsLocationFilterModal from '@/components/Vessels/VesselsLocationFilterModal.vue';
import HelpersMixin from '@/mixins/helpers.mixin';
import UiKitSelect from '@/components/UiKit/UiKitSelect.vue';
import states from 'states-us';

@Component({
  components: { UiKitSelect, VesselsLocationFilterModal, UiKitInput, FiltersIcon, LocationIcon }
})
export default class VesselFilters extends mixins(HelpersMixin, Vue) {
  get filters(): SearchVesselsParams {
    return this.$store.state.vessels.filters;
  }

  get filtersCount(): number {
    const clearedFilters = clearEmpty(this.filters);

    return Object
      .entries(clearedFilters)
      .filter(([ key, value ]) => ![ '0,', '0,NaN' ].includes(value))
      .length;
  }

  get minPrice() {
    const value = this.filters.price_between!.split(',')[0];

    if (value === '0') {
      return null;
    }

    return value;
  }

  set minPrice(value) {
    value = !value ? '0' : value;
    const maxPrice = !this.maxPrice ? 'NaN' : this.maxPrice;

    const priceBetween = [ value, maxPrice ].join(',');

    this.addFilter({ price_between: priceBetween });
  }

  get maxPrice() {
    const value = this.filters.price_between!.split(',')[1];

    if (isNaN(parseFloat(value))) {
      return null;
    }

    return value;
  }

  set maxPrice(value) {
    value = !value ? 'NaN' : value;
    const minPrice = !this.minPrice ? '0' : this.minPrice;

    const priceBetween = [ parseFloat(minPrice) || 0, parseFloat(value) ].join(',');

    this.addFilter({ price_between: priceBetween });
  }

  get minYear() {
    const value = this.filters.year_between!.split(',')[0];

    if (value === '0') {
      return null;
    }

    return value;
  }

  set minYear(value) {
    value = !value ? '0' : value;
    const maxYear = !this.maxYear ? this.lastYear : this.maxYear;

    const yearBetween = [ value, maxYear ].join(',');

    this.addFilter({ year_between: yearBetween });
  }

  get maxYear() {
    const value = this.filters.year_between!.split(',')[1];

    if (isNaN(parseFloat(value))) {
      return null;
    }

    return value;
  }

  set maxYear(value) {
    value = !value ? this.lastYear as any as string : value;
    const minYear = !this.minYear ? '0' : this.minYear;

    const yearBetween = [ parseFloat(minYear) || 0, parseFloat(value as string) ].join(',');

    this.addFilter({ year_between: yearBetween });
  }

  get minLength() {
    return this.filters.length_between!.split(',')[0];
  }

  set minLength(value) {
    value = !value ? '0' : value;
    const maxLength = !this.maxLength ? 'NaN' : this.maxLength;

    const lengthBetween = [ parseFloat(value) || 0, parseFloat(maxLength) ].join(',');

    this.addFilter({ length_between: lengthBetween });
  }

  get maxLength() {
    return this.filters.length_between!.split(',')[1];
  }

  set maxLength(value) {
    value = !value ? 'NaN' : value;
    const minLength = !this.minLength ? '0' : this.minLength;

    const lengthBetween = [ minLength, value ].join(',');

    this.addFilter({ length_between: lengthBetween });
  }

  get lastYear() {
    return (new Date()).getFullYear() + 1;
  }

  get states(): Array<{ value: string, title: string }> {
    return states.map((state) => {
      return {
        value: state.abbreviation,
        title: state.name
      };
    });
  }

  protected addFilter(filters: SearchVesselsParams) {
    this.$store.commit(SET_VESSELS_FILTER, filters);
  }

  protected search() {
    this.$store.commit(CLEAR_VESSELS);

    this.$store.commit(SET_PAGE, 1);

    this.$store.dispatch(SEARCH_VESSELS);

    this.$emit('complete');
  }

  protected clearFilters() {
    this.$store.commit(RESET_STATE_FILTERS);
    this.$store.commit(CLEAR_VESSELS);

    this.$store.dispatch(SEARCH_VESSELS);
  }
}
